import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormControl } from '@angular/forms';
import { startWith } from 'rxjs';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'y42-threshold-form-part[failedConditionControl][failedByConditionControl]',
  templateUrl: './error-threshold-form-part.component.html',
  styleUrls: ['./error-threshold-form-part.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorThresholdFormPartComponent implements OnInit {
  @Input() failedConditionControl!: FormControl<'absolute' | 'relative'>;
  @Input() failedByConditionControl!: FormControl<number>;

  ngOnInit(): void {
    this.failedConditionControl.valueChanges
      .pipe(
        startWith(0),
        tap(() => this.failedByConditionControl.updateValueAndValidity()),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
